import { Config, isProduction } from '@/config';

// Wrapper for Microsoft Clarity. Injects the official tracking snippet only in
// production and only when a project id is configured, so local/dev sessions are
// never recorded.
export const Clarity = Object.freeze({
  init: () => {
    if (!isProduction() || !Config.clarity) {
      return;
    }

    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', Config.clarity);
  },
});
